
















































































































import {
  defineComponent,
  ref,
  computed,
  watch,
  useContext,
  onMounted,
} from '@nuxtjs/composition-api'
import VueSkeletonLoader from 'skeleton-loader-vue'
import CitySelect from '../components/FormInput/CitySelect.vue'
import { useServerFetch } from '@/composition/useServerFetch'
import { Logger } from '@/composition/Logger'
import { CityModel } from '@/contracts/api/QueryCites/QueryCities.Response'
import { SectionData } from '@/contracts/SectionData'
import CardTileOffice from '@/components/Cards/CardTileOffice.vue'
import Loader from '@/plugins/loader/Load.vue'
import SectionBasic from '@/components/SectionBasic.vue'
import PaginationList from '@/components/PaginationList.vue'
import { sectionCoreProps } from '@/mixins/sectionCore'
import { Office } from '@/apollo/adapters/modules/officeAdapter'

export default defineComponent({
  name: 'SectionListOffices',
  components: {
    CitySelect,
    Loader,
    SectionBasic,
    CardTileOffice,
    PaginationList,
    VueSkeletonLoader,
  },
  mixins: [sectionCoreProps],
  props: {
    itemsPerPageDesktop: {
      type: Number,
      default: 6,
    },
    itemsPerPageMobile: {
      type: Number,
      default: 4,
    },
    city: {
      type: String,
      default: '',
    },
  },
  setup(props, { root }) {
    const selectedCity = ref<CityModel | null>()
    const { $api } = useContext()
    const { itemsPerPageMobile, itemsPerPageDesktop, city } = props
    const mappedSectionData = computed<SectionData>(
      (): SectionData => ({
        ...props.sectionData,
        sectionMainTitle: offices.value.length
          ? props.sectionData.sectionMainTitle
          : 'Мы ничего не нашли по вашему запросу',
      })
    )
    const sectionClass = computed(() =>
      mappedSectionData.value.sectionStyle === 'Да'
        ? 'office_new'
        : 'office_old'
    )

    const isNewLoaderStyle = computed(
      () => mappedSectionData.value.sectionStyle === 'Да'
    )

    const activePage = ref<number>(1)
    const excludeType = ref<string>('claim')
    const loading = ref<boolean>(false)
    const search = ref<string | null>(null)
    const total = ref<number>(0)
    const offices = ref<Office[]>([])
    const searchNearOffices = ref<boolean>(false)
    const isMobile = computed<boolean>(
      (): boolean => root.$store.getters['mediaQuery/isMobileMq']
    )
    const showSearch = computed<boolean>((): boolean => !(city && city.length))
    const itemsPerPage = computed<number>((): number =>
      isMobile.value ? itemsPerPageMobile : itemsPerPageDesktop
    )
    const changePage = (page: number) => {
      activePage.value = page
      getOffices()
    }

    const findNearOffices = () => {
      selectedCity.value = null
      searchNearOffices.value = true
      getOffices()
    }

    const getOffices = async () => {
      try {
        loading.value = true

        const params: any = {
          page: activePage.value,
          perPage: itemsPerPage.value,
          excludeType: isNewLoaderStyle ? excludeType.value : '',
        }
        if (searchNearOffices.value) {
          params.checkLocation = true
        } else if (search.value || city) {
          params.city = showSearch.value ? search.value : city
        }
        const response = await $api.requests.getOfficesByBounds(params)
        const result = response?.data || {}

        offices.value = result.data || []

        total.value = result.total || 0
        //
        loading.value = false
      } catch (e) {
        Logger.error(e)
      }
    }

    useServerFetch(getOffices)

    const inputHandler = (e: any) => {
      search.value = e.value.city
      searchNearOffices.value = false
      if (search.value) {
        activePage.value = 1
      }
      getOffices()
    }

    watch(isMobile, (isMob: boolean) => {
      activePage.value = isMob
        ? Math.floor(
            ((activePage.value - 1) * itemsPerPageDesktop) /
              itemsPerPageMobile +
              1
          )
        : Math.floor(
            ((activePage.value - 1) * itemsPerPageMobile) /
              itemsPerPageDesktop +
              1
          )
    })

    return {
      selectedCity,
      total,
      itemsPerPage,
      activePage,
      isMobile,
      offices,
      loading,
      showSearch,
      findNearOffices,
      mappedSectionData,
      changePage,
      getOffices,
      inputHandler,
      sectionClass,
      isNewLoaderStyle,
    }
  },
})
